<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">{{ title }}</h3>
    <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
  </div>
  <form [formGroup]="form" (ngSubmit)="onCreate()">
    <mat-dialog-content>
      <ndt-extension-chip-input
        [accountId]="extension?.accountId"
        formControlName="extensionsOrPhoneNumbersToDial"
        isRequired="true"
      ></ndt-extension-chip-input>
      <mat-form-field>
        <mat-label>Timeout (Seconds)</mat-label>
        <input
          matInput
          type="number"
          autocomplete="off"
          formControlName="timeout"
          [name]="'timeout (seconds)'"
          required
          />
          @if (form.get('timeout')?.hasError('required')) {
            <mat-error> Timeout is required </mat-error>
          }
          @if (form.get('timeout')?.hasError('min') || form.get('timeout')?.hasError('max')) {
            <mat-error
              >Timeout must be between 1-50
            </mat-error>
          }
          @if (form.get('timeout')?.hasError('pattern')) {
            <mat-error>Timeout must be numeric</mat-error>
          }
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button type="submit" title="Create" mat-raised-button>Save</button>
      </mat-dialog-actions>
    </form>
  </lcs-loading-overlay>
